module.exports = __webpack_public_path__ + "img/smart-notas.695f3d10.png";